import React, {useEffect} from 'react';
import {Header} from '../../components';

export const Home: React.FC = () => {
  useEffect(() => {
    // process.env.REACT_APP_RECCO_MARKETING_URL && (window.location.href = process.env.REACT_APP_RECCO_MARKETING_URL);
  }, []);

  return (
    <div className="home">
      <Header />
      <div className="container" />
    </div>
  );
};
